import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import Text from '@helvetia/components/Text'
const NotAuthorizedRaw: React.SFC<WithNamespaces> = ({ t }) => {
  return (
    <>
      <Text size="lBold" as="div">
        {t('error.401.error')}
      </Text>
      <Text size="m" as="div">
        {t('error.401.suberror')}
      </Text>
    </>
  )
}

export const NotAuthorized = withNamespaces()(NotAuthorizedRaw)
